import React, { useRef, useState } from "react";
import { Textarea } from "@emisgroup/ui-input";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { ErrorIcon } from "./ErrorIcon";
import "./style.scss";

export const OrganisationCDBField: React.FC<{
  initialValue?: string;
  infoText: string;
  label: string;
  errorText: string;
  onChange?: (value: string, error: string) => void;
}> = ({ initialValue = "", infoText, errorText: error, label, onChange }) => {
  const { t: translate } = useTranslation();
  const [value, setValue] = useState(initialValue);
  const [errorText, setErrorText] = useState(error);
  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const newValue = e.target.value;
    setValue(newValue);

    let error = "";
    if (newValue.length === 0) {
      error = translate("AddExecution.OrganisationCDB.ErrorText");
    } else {
      const codes = newValue.split(/[\s,]+/).filter(Boolean);
      const invalidCodes = codes.filter(code => !/^CDB-\d{1,6}$/.test(code));
      if (invalidCodes.length > 0) {
        error = `${translate("AddExecution.OrganisationCDB.InvalidCdbNumber")} ${invalidCodes.join(", ")}`;
      }
    }
    setErrorText(error);
    if (onChange) onChange(newValue, error);
  };

  return (
    <div className="summary-entry__fields__organisation_cdb" style={{ marginBottom: 16 }}>
      <label
        htmlFor="executionCdbs"
        className="summary-entry__fields__organisation_cdb_label"
      ><span>*</span> {label}</label>
      <Textarea
        ref={inputRef}
        id="executionCdbs"
        name="executionCdbs"
        data-testid="executionCdbs"
        rows={5}
        value={value}
        onChange={handleChange}
        invalid={ !!errorText }
        aria-invalid={!!errorText}
        aria-describedby={errorText ? "execution-cdbs-error" : undefined}
        className={errorText ? "invalid-cdbs" : ""}
      />
      {errorText ? ( <div id="execution-cdbs-error"><ErrorIcon/>{errorText}</div>) :
        (
          <div className="summary-entry__fields__organisation_cdb_info">
            {infoText}
          </div>
        )}
    </div>
  );
};
